z<template>
  <div class="personal">
    <Aheader :realIndex="5"></Aheader>
    <div class="banner">
      <p>Personal Information</p>
    </div>
    <div class="content">
      <p class="path">
        <router-link to="/home">Home Page</router-link>
        <span style="color:#999"> / </span>
        <span> Personal Information </span>
      </p>
      <div class="page-container">
        <el-row class="avatar-wrapper">
          <img src="../assets/img/home-head.png" alt="" />
        </el-row>
        <el-form
          class="userInfo-form-content"
          label-position="top"
          ref="userInfoForm"
          :model="userInfoForm"
          :rules="userInfoRules"
          hide-required-asterisk
          :show-message="false"
        >
          <el-form-item class="email" label="mailbox">
            <p>{{ userInfoForm.username }}</p>
          </el-form-item>
          <el-form-item
            prop="password"
            label="password"
            @mouseover.native="showReviseText(true)"
            @mouseout.native="showReviseText(false)"
          >
            <el-input
              type="password"
              v-model="userInfoForm.password"
              autocomplete="off"
              placeholder="Please input a password"
              disabled
            ></el-input>
            <span
              class="change-pw"
              v-show="reviseTextVisible"
              @click="showChangePasswordDialog"
              >modify</span
            >
          </el-form-item>
          <el-form-item prop="name" label="full name">
            <el-input
              type="text"
              v-model.trim="userInfoForm.name"
              autocomplete="off"
              placeholder="Please enter your name"
            ></el-input>
          </el-form-item>
          <el-form-item prop="contact" label="cell-phone number">
            <el-input
              type="text"
              v-model.number="userInfoForm.contact"
              autocomplete="off"
              placeholder="Please enter your mobile number"
            ></el-input>
          </el-form-item>
          <el-form-item prop="department" label="Company unit">
            <el-input
              type="text"
              v-model.trim="userInfoForm.department"
              autocomplete="off"
              placeholder="Please enter company unit"
            ></el-input>
          </el-form-item>
          <el-form-item class="btn-group">
            <el-button @click="signOut">Log out</el-button>
            <el-button @click="save('userInfoForm')">Preservation</el-button>
          </el-form-item>
        </el-form>
        <!-- 修改密码弹框 -->
        <change-password-dialog
          ref="changePasswordDialog"
          :username="userInfoForm.username"
          @signOut="signOut"
        ></change-password-dialog>
      </div>
    </div>
    <Afooter></Afooter>
  </div>
</template>

<script>
import { Message } from 'element-ui'
import Aheader from '../components/aheader.vue'
import Afooter from '../components/afooter.vue'
import http from '../utils/http'
import api from '@/utils/api'
import validate from '@/utils/validate'
import ChangePasswordDialog from '../components/change-password-dialog.vue'

export default {
  name: 'Personal',
  components: {
    Aheader,
    ChangePasswordDialog,
    Afooter
  },
  data () {
    return {
      timer: null,
      userInfoForm: {
        username: '',
        password: '************',
        name: '',
        contact: '',
        department: ''
      },
      reviseTextVisible: false,
      userInfoRules: {
        name: [
          {
            validator: (rule, value, callback) => {
              let error = []
              let checkRes = validate.checkUsername(value)
              if (!checkRes.data) {
                error.push(checkRes.msg)
              }
              callback(error)
            },
            trigger: 'blur'
          },
          { required: true, trigger: 'blur' }
        ],
        contact: [
          {
            validator: (rule, value, callback) => {
              let error = []
              let checkRes = validate.checkPhone(value)
              if (!checkRes.data) {
                error.push(checkRes.msg)
              }
              callback(error)
            },
            trigger: 'blur'
          },
          { required: true, trigger: 'blur' }
        ],
        department: [{ required: true, trigger: 'blur' }]
      },
      userInfo: {}
    }
  },
  created () {
    this.$store.commit('toTop')
    api.checkLogin().then(res => {
      if (res.data.code === 200) {
        http.get(`/web/selectUserByUserName?pusername=${res.data.msg}`, {}, resp => {
          if (resp.code === 200) {
            this.userInfoForm.username = resp.data.username
            this.userInfoForm.contact = resp.data.contact
            this.userInfoForm.name = resp.data.name
            this.userInfoForm.department = resp.data.department
          } else {
            Message.error(`${resp.msg}`)
          }
        })
      } else {
        Message.error(`${res.data.msg}`)
      }
    })
  },
  methods: {
    // 登出
    signOut () {
      http.post('/web/logout', {}, res => {
        if (res.code === 200) {
          Message.success('Logout successful')
          this.$router.push('/home')
        } else {
          Message.error(`${res.msg}`)
        }
      })
    },
    save (form) {
      // 保存
      this.$refs[form].validate(valid => {
        if (valid) {
          this.$utils.debounce(this.updateUser(), 500)
        }
      })
    },
    updateUser () {
      const { username, name, department, contact } = this.userInfoForm
      const data = { username, name, department, contact }
      http.post(`/web/updateUserByUserName`, data, res => {
        if (res.code === 200) {
          this.$store.commit('getName', name)
          Message.success('Modified successfully')
        } else {
          Message.error(`${res.msg}`)
        }
      })
    },
    showChangePasswordDialog () {
      // 修改密码
      this.$refs['changePasswordDialog'].open()
    },
    showReviseText (state) {
      clearTimeout(this.timer)
      if (!state) {
        this.timer = setTimeout(() => {
          this.reviseTextVisible = state
        }, 500)
      } else {
        this.reviseTextVisible = state
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.personal {
  box-sizing: border-box;
  min-width: vw(1200);
}
.banner {
  margin-top: vw(81);
  min-width: vw(1200);
  height: vw(356);
  background-image: url('../assets/img/personal-banner.png');
  background-size: 100% 100%;
  padding-top: vw(130);
  box-sizing: border-box;
  p {
    width: vw(1200);
    margin: 0 auto;
    font-size: vw(42);
    color: #333333;
  }
}
.content {
  width: vw(1200);
  margin: 0 auto;
  box-sizing: border-box;
  padding-top: vw(25);
  .path {
    color: #333;
    font-size: vw(16);
    margin-bottom: vw(42);
    a {
      color: #999;
      cursor: pointer;
      &:hover {
        color: $theme_color;
      }
    }
  }
  .page-container {
    width: vw(1200);
    .avatar-wrapper {
      margin: vw(50) 0;
      .avatar {
        display: inline-block;
        width: vw(42);
        height: vw(42);
      }
    }
    .userInfo-form-content {
      width: 100%;
      color: #333333;
      .el-form-item {
        width: vw(540);
        border-bottom: 1px solid #dddddd;
        margin: vw(40) 0 0 0;
        &:first-child {
          margin-top: 0;
        }
        >>> .el-form-item__label {
          padding: 0;
          height: 100%;
          font-size: vw(16);
        }
        >>> .el-form-item__content {
          .el-input {
            &.is-disabled {
              .el-input__inner {
                background: none;
              }
            }
            .el-input__inner {
              border: none;
              padding: 0;
              &[type='password'] {
                cursor: pointer;
              }
            }
            // @include input-style(14);
          }
          .change-pw {
            position: absolute;
            font-size: vw(14);
            color: #005aff;
            right: 0;
            z-index: 1000;
            cursor: pointer;
            &:hover {
              color: $theme_color-hover;
            }
          }
        }
        &.is-error {
          border-bottom: 1px solid red;
        }
        &.email {
          border-bottom: 0;
          p {
            font-size: vw(14);
            color: #333333;
          }
        }
      }
      .btn-group {
        margin-bottom: vw(137);
        border: none;
        .el-button {
          height: vw(37);
          font-size: vw(14);
          color: #ffffff;
          border-radius: 4px;
          border: none;
          padding: 0 vw(30);
          &:focus {
            outline: 0;
          }
          &:first-child {
            background: #999;
            margin-right: vw(6);
            &:hover {
              background: #ccc;
            }
          }
          &:last-child {
            background: $theme_color;
            &:hover {
              background: $theme_color-hover;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/personal.vue